import { createSlice, PayloadAction } from '@reduxjs/toolkit'

const initialState = ''

const topPurchasedBrandDonutSlices = createSlice({
  name: 'topPurchasedBrandDonut',
  initialState,
  reducers: {
    setTopPurchasedBrandDonut(_state, action: PayloadAction<{ topPurchasedBrandLabel: string }>) {
      return action.payload.topPurchasedBrandLabel
    },
  },
})

export const { setTopPurchasedBrandDonut } = topPurchasedBrandDonutSlices.actions

export default topPurchasedBrandDonutSlices.reducer
